import { makeStyles } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UIkit'

export const useRequestStyles = makeStyles(theme => ({
  title: {
    color: GRAY_COLORS[900],
    fontSize: 18
  },
  subtitle: {
    color: GRAY_COLORS[600],
    fontSize: 14
  },
  border: {
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    padding: '20px 24px',
    marginTop: '24px'
  },
  chatBorder: {
    position: 'relative',
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    padding: '20px 24px',
    marginTop: '24px',
    '&::before': {
      content: '""',
      position: 'absolute',
      left: '0px',
      right: '0px',
      top: '70px',
      borderTop: '1px solid #EAECF0'
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      left: '0px',
      right: '0px',
      bottom: '85px',
      borderBottom: '1px solid #EAECF0'
    }
  }
}))
